import { NgModule } from '@angular/core';
import { CompanyCoreModule } from './company-core/company-core.module';
import { DivisionCoreModule } from './division-core/division-core.module';
import { GameCoreModule } from './game-core/game-core.module';
import { LearningPlayerCoreModule } from './learning-player-core/learning-player-core.module';
import { ValuesGamePlayerCoreModule } from './values-game-player-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    ValuesGamePlayerCoreModule,
    LearningPlayerCoreModule,
    CompanyCoreModule,
    DivisionCoreModule,
    GameCoreModule,
  ],
})
export class TalentLitmusCoreModule {}
